import { combineReducers, type UnknownAction } from '@reduxjs/toolkit'

import { RESET_GLOBAL_APP_STATE } from '@/app/actions'
import { baseApiSlice } from '@/legacy-api/base-api-slice'
import modelListSlice from '@/reducers/model-list'
import tradeBlotterSlice from '@/reducers/trade-blotter'
import tradeDeskTradeBlotterSlice from '@/reducers/trade-desk-trade-blotter'

import accountDetailsSlice from './account-details'
import accountListSlice from './account-list'
import allocationListSlice from './allocation-list'
import allocationRunSlice from './allocation-run'
import holdingListSlice from './holding-list'
import modelBuilderSlice from './model-builder'
import modelDetailsSlice from './model-details'
import proposalBuilderSlice from './proposal-builder'
import proposalsSlice from './proposals'
import riskControlsSlice from './risk-controls'
import sleeveManagementSlice from './sleeve-management'

const combinedReducer = combineReducers({
  [baseApiSlice.reducerPath]: baseApiSlice.reducer,
  [tradeBlotterSlice.reducerPath]: tradeBlotterSlice.reducer,
  [accountListSlice.reducerPath]: accountListSlice.reducer,
  [accountDetailsSlice.reducerPath]: accountDetailsSlice.reducer,
  [allocationListSlice.reducerPath]: allocationListSlice.reducer,
  [allocationRunSlice.reducerPath]: allocationRunSlice.reducer,
  [modelListSlice.reducerPath]: modelListSlice.reducer,
  [modelDetailsSlice.reducerPath]: modelDetailsSlice.reducer,
  [modelBuilderSlice.reducerPath]: modelBuilderSlice.reducer,
  [proposalsSlice.reducerPath]: proposalsSlice.reducer,
  [riskControlsSlice.reducerPath]: riskControlsSlice.reducer,
  [sleeveManagementSlice.reducerPath]: sleeveManagementSlice.reducer,
  [proposalBuilderSlice.reducerPath]: proposalBuilderSlice.reducer,
  [holdingListSlice.reducerPath]: holdingListSlice.reducer,
  [tradeDeskTradeBlotterSlice.reducerPath]: tradeDeskTradeBlotterSlice.reducer,
})

// Root reducer that wraps the app reducer and handles the reset action
export const rootReducer = (
  state: ReturnType<typeof combinedReducer> | undefined,
  action: UnknownAction,
) => {
  // When the RESET_GLOBAL_APP_STATE action is dispatched, return undefined as the state
  // This will cause Redux to reinitialize the state with the initial values defined in each slice
  if (action.type === RESET_GLOBAL_APP_STATE) {
    return combinedReducer(undefined, action)
  }

  return combinedReducer(state, action)
}
